export const testAttributes = {
    LEARNING_CENTER_LANDING_PAGE: 'learning-center-landing-page',
    LEARNING_CENTER_LANDING_PAGE_HEAD_CONTENT: 'learning-center-landing-page-head-content',
    LEARNING_CENTER_LANDING_PAGE_FEATURED: 'learning-center-landing-page-featured',
    LEARNING_CENTER_LANDING_PAGE_CATEGORY: 'learning-center-landing-page-category',
    LEARNING_CENTER_LANDING_PAGE_GRID_CONTAINER: 'learning-center-landing-page-grid-container',
}